import styled, { css } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';
import { SectionTitle } from 'src/pages/VerificationPage/components/VerificationPageFlow/VerificationPageSuccessPageFlow.styled';

export const Backdrop = styled.div`
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  max-height: 95vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  width: 90vw;
  padding: 2rem 0.5rem 0.5rem;

  ${media.w.min.px576(css`
    width: 28rem;
    padding: 2rem;
    max-height: 90vh;
  `)}
`;

export const ModalHeader = styled(SectionTitle)`
  margin: 0 0.75rem 1rem;

  ${media.w.min.px576(css`
    margin: 0 0 1.1875rem;
  `)}
`;
